import * as R from 'ramda';
import React from 'react';
import {pure} from 'recompose';

import BootstrapSelect from 'iss/widgets/bootstrap/Select';
import {selectorFormComponent} from 'iss/widgets/form/Field';

require('react-select/dist/react-select.css');

export const Select = selectorFormComponent(pure(({
  onChange, id, value, multi, filterOption,
  isValidNewOption = R.not(R.equals("")), ...props
}) => {
  var valueToOption;
  if (props.async) {
    if (!props.toOption) throw "toOption is required for async selects";
    valueToOption = props.toOption;
  } else {
    valueToOption = (value) => R.find(R.propEq(value, "value"), props.options);
  }

  var toValue, toOption;
  if (multi) {
    toValue = R.map(R.prop("value"));
    toOption = R.map(valueToOption);
  } else {
    toValue = R.propOr(null, "value");
    toOption = valueToOption;
  }
  const realFilterOption = filterOption ? ({value}, search) => filterOption(value, search) : null;
  const realIsValidNewOption = ({label}) => isValidNewOption(label);

  return <BootstrapSelect id={id} onChange={(option) => onChange(toValue(option))}
    ignoreAccents={false}
    value={toOption(value)} multi={multi} isValidNewOption={realIsValidNewOption}
    filterOption={realFilterOption} {...props} />;
}));



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/form/input/Select.jsx